import CloseIcon from '@mui/icons-material/Close';
import { LabeledDivider, DividerIconButton } from '@components/LabeledDivider';
import { useTranslation } from '@hooks';

const PageDivider = ({ pageIndex, isView, onDelete }) => {
    const { t } = useTranslation();

    return (
        <LabeledDivider label={`${t('FeedbackSurveys.page')} ${pageIndex + 1}`}>
            {!isView && pageIndex > 0 && (
                <DividerIconButton onClick={() => onDelete(pageIndex)} size="small">
                    <CloseIcon />
                </DividerIconButton>
            )}
        </LabeledDivider>
    );
};

export default PageDivider;
